import { apiService } from '@/services/APIService';

export default {

  getExports(params) {
    return apiService.get('/exports', params);
  },

};
